import { z } from 'zod';
/**
 * Transition-target schema for `PATCH /organizations/:slug/status`.
 *
 * Accepts ONLY the legal transition TARGETS — `'onboarding'`, `'active'`,
 * and `'closed'`. The other two members of the `OrganizationStatus` enum
 * (`'testing'` and `'training'`) are deliberately excluded: per the status
 * DAG (`packages/domain/src/organization-status.ts`) nothing transitions INTO
 * them (they are creation-only entry states). Allowing them through this DTO
 * would give callers a way to push the aggregate into a state the domain
 * forbids. `'onboarding'` IS a valid target via the `testing → onboarding`
 * edge (technical validation complete → client onboarding).
 *
 * `.strict()` rejects extra fields so that a caller cannot smuggle additional
 * keys (e.g. `from`, `forceClosed`, `actorOverride`) past the validation
 * boundary; the domain is the single source of truth for transition policy.
 *
 * This is a pure validator — no domain logic, no framework imports. The
 * downstream use case (`TransitionOrganizationStatusUseCase`) hands the
 * validated literal to `Organization.transitionStatus(...)` which enforces
 * the DAG and throws `InvalidStatusTransitionError` on disallowed edges.
 */
export const transitionOrganizationStatusSchema = z
    .object({ status: z.enum(['onboarding', 'active', 'closed']) })
    .strict();
//# sourceMappingURL=transition-organization-status.js.map